import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './_styles_/PasswordPolicyPopup.css';
import ModalDialog from '../ModalDialog';
import { passwordPolicyType } from '../../types';

PasswordPolicyPopup.propTypes = {
    hideDialog: PropTypes.func.isRequired,
    passwordPolicy: passwordPolicyType.isRequired,
};

function PasswordPolicyPopup(props) {
    const {
        hideDialog,
        passwordPolicy,
    } = props;
    const {
        passwordMinLength,
        passwordCheckSyntax,
        passwordMinAlphas,
        passwordMinLowers,
        passwordMinUppers,
        passwordMinDigits,
        passwordMinCategories,
        passwordMinSpecials,
        passwordMin8bit,
        passwordMaxRepeats,
        passwordMinTokenLength,
        passwordHistory,
        passwordInHistory,
    } = passwordPolicy;
    const { t } = useTranslation();
    const title = t('passwords.policy.title');
    return (
        <ModalDialog onCancel={hideDialog}>
            <div className="password-policy-popup-dialog">
                <div aria-label={title}>{title}</div>
                <ul>
                    {passwordCheckSyntax && (
                        <>
                            {passwordMinLength > 0 && <li>{t('passwords.policy.min-length', { minLength: passwordMinLength })}</li>}
                            {passwordMinAlphas > 0 && <li>{t('passwords.policy.min-alphas', { minAlphas: passwordMinAlphas })}</li>}
                            {passwordMinLowers > 0 && <li>{t('passwords.policy.min-lowers', { minLowers: passwordMinLowers })}</li>}
                            {passwordMinUppers > 0 && <li>{t('passwords.policy.min-uppers', { minUppers: passwordMinUppers })}</li>}
                            {passwordMinDigits > 0 && <li>{t('passwords.policy.min-digits', { minDigits: passwordMinDigits })}</li>}
                            {passwordMinSpecials > 0 && <li>{t('passwords.policy.min-specials', { minSpecials: passwordMinSpecials })}</li>}
                            {passwordMin8bit > 0 && <li>{t('passwords.policy.min-8bit', { min8bit: passwordMin8bit })}</li>}
                            {passwordMinCategories > 0 && <li>{t('passwords.policy.min-categories', { minCategories: passwordMinCategories })}</li>}
                            {passwordMaxRepeats > 0 && <li>{t('passwords.policy.max-repeats', { maxRepeats: passwordMaxRepeats })}</li>}
                            {passwordMinTokenLength > 0 && <li>{t('passwords.policy.min-token-length', { minTokenLength: passwordMinTokenLength })}</li>}
                        </>
                    )}
                    {passwordHistory && <li>{t('passwords.policy.in-history', { inHistory: passwordInHistory })}</li>}
                </ul>
                <div className="buttons">
                    <button className="button button-bordered close-button" type="button" onClick={hideDialog}>{t('button.close')}</button>
                </div>
            </div>
        </ModalDialog>
    );
}

export default PasswordPolicyPopup;
